import SpepInstructionCard from "./step-instruction-card";

export default function PredecessorMaterialInstruction() {
  return (
    <div className="linking-group--right--content p-1 pr-12">
      <SpepInstructionCard
        title="Note:"
        detail="This Material cannot have any downstream links, as linking a chain of Materials is not supported currently."
      />
      <SpepInstructionCard
        title=""
        detail="Unlink the Predecessors of this Material to link downstream Materials."
      />
    </div>
  );
}
